<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-row class="fill-height" no-gutters>
          <v-col class="col-12">
            <v-row>
              <v-col class="col-12">
                <v-card-title>
                  <v-row>
                    <v-col class="col-6 col-md-4">
                      <h1 class="primary-color">Jobs</h1>
                    </v-col>
                    <v-spacer />
                    <v-col class="col-6 col-md-2">
                      <v-btn class="new-item-btn float-right" block @click="openCreateJob">
                        <v-icon size="20">mdi-plus</v-icon>
                        &nbsp;&nbsp;Create job
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>

                <v-alert
                  v-if="messageCreateJob"
                  outlined
                  :color="successfullCreateJob ? 'success' : 'error'"
                  :icon="successfullCreateJob ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageCreateJob }}
                </v-alert>
                <v-alert
                  v-if="messageDeleteJob"
                  outlined
                  :color="successfullDeleteJob ? 'success' : 'error'"
                  :icon="successfullDeleteJob ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageDeleteJob }}
                </v-alert>
                <v-alert
                  v-if="messageEditJob"
                  outlined
                  :color="successfullEditJob ? 'success' : 'error'"
                  :icon="successfullEditJob ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageEditJob }}
                </v-alert>
                <v-data-table
                  :headers="headers"
                  :items="jobs"
                  item-key="id"
                  :loading="loading"
                  loading-text="Loading... Please, wait..."
                  :server-items-length="pagination.totalItems"
                  :items-per-page="pagination.itemsPerPage"
                  :page.sync="pagination.page"
                  item-class="text-wrap"
                  @update:page="handlePageChange"
                >
                  <template #[`item.createdAt`]="{ item }">
                    {{ item.createdAt | formatDate }}
                  </template>
                  <template #[`item.actions`]="{ item }">
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openShowDetails(item)">
                          <v-icon size="20" color="primary">mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Show details</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openEditJob(item)">
                          <v-icon size="20" color="primary">mdi-square-edit-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit job</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openDeleteJob(item)">
                          <v-icon size="20" color="error">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete job</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-alert
              v-if="messageJobs"
              class="mt-4"
              outlined
              :color="successfullJobs ? 'success' : 'error'"
              :icon="successfullJobs ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageJobs }}
            </v-alert>

            <v-alert
              v-if="messageContexts"
              class="mt-4"
              outlined
              :color="successfullContexts ? 'success' : 'error'"
              :icon="successfullContexts ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageContexts }}
            </v-alert>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <v-dialog v-model="createJobDialog" max-width="600" persistent content-class="no-scroll">
      <v-card class="no-scroll">
        <v-form ref="createJobForm" @submit.prevent="createJob">
          <v-card-title class="px-6">
            <h5 class="primary-color">Create Job</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="job.name"
                    class="py-0 mb-6 no-border-radius"
                    label="Name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-select
                    ref="menuContextsCreate"
                    v-model="job.contexts"
                    class="py-0 mb-6 no-border-radius"
                    label="Contexts"
                    :items="contextsCreate"
                    item-text="name"
                    item-value="id"
                    multiple
                    :loading="loadingContextsCreate"
                    attach
                  />
                </v-col>
                <v-col cols="12" class="py-0">
                  <p class="information-text">
                    <v-icon size="20" color="primary">mdi-information</v-icon>&nbsp;&nbsp;It is not
                    necessary for you to select any context right now. However, please, note that
                    the order of the contexts will affect their use in the avatar.
                  </p>
                </v-col>
              </v-row>
              <v-alert
                v-if="messageCreateJobInside"
                class="mb-0 mt-3"
                outlined
                :color="successfullCreateJobInside ? 'success' : 'error'"
                :icon="successfullCreateJobInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageCreateJobInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="cancelCreateJob"> Cancel </v-btn>
            <v-btn v-if="!creatingJob" type="submit" class="ok-modal"> Create </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editJobDialog" max-width="600" persistent>
      <v-card>
        <v-form ref="editJobForm" @submit.prevent="editJob">
          <v-card-title class="px-6">
            <h5 class="primary-color">Update Job</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="itemToEdit.name"
                    class="py-0 mb-6 no-border-radius"
                    label="Name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-select
                    v-model="itemToEdit.contexts"
                    class="py-0 mb-6 no-border-radius"
                    label="Contexts"
                    :items="contextsEdit"
                    item-text="name"
                    item-value="id"
                    multiple
                  />
                </v-col>
                <v-col cols="12" class="py-0">
                  <p class="information-text">
                    <v-icon size="20" color="primary">mdi-information</v-icon>&nbsp;&nbsp;Please,
                    note that the order of the contexts will affect their use in the avatar.
                  </p>
                </v-col>
              </v-row>

              <v-alert
                v-if="messageEditJobInside"
                class="mb-0 mt-3"
                outlined
                :color="successfullEditJobInside ? 'success' : 'error'"
                :icon="successfullEditJobInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageEditJobInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="editJobDialog = false"> Cancel </v-btn>
            <v-btn v-if="!editingJob" type="submit" class="ok-modal"> Update </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteJobDialog" max-width="500">
      <v-card>
        <v-card-title class="px-6">
          <h5 class="primary-color">Delete Job</h5>
        </v-card-title>
        <v-card-text class="mt-4 pb-0 px-6">
          <p class="mb-0">
            Do you really want to delete the selected job? <br />
            If so, press Confirm.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn text class="cancel-modal" @click="deleteJobDialog = false"> Cancel </v-btn>

          <template v-if="!deletingJob">
            <v-btn class="ok-modal" @click="deleteJob"> Confirm </v-btn>
          </template>
          <v-btn v-else class="ok-modal" disabled @click="deleteJob">
            <v-progress-circular indeterminate color="primary" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDetailsJobDialog" max-width="800">
      <v-card>
        <v-form ref="detailsJobForm">
          <v-card-title class="px-6">
            <h5 class="primary-color">Details</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Name:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">{{ itemToShow.name }}</p>
                </v-col>
              </v-row>
              <v-row v-if="itemToShow.contexts !== undefined && itemToShow.contexts.length == 0">
                <v-col cols="3">
                  <h6 class="details-subtitles primary-color">Contexts:</h6>
                </v-col>
                <v-col cols="9">
                  <p class="mb-0">Job with no associated contexts</p>
                </v-col>
              </v-row>

              <v-row v-else>
                <v-col cols="12" class="pb-0">
                  <h6 class="details-subtitles primary-color">Contexts:</h6>
                </v-col>
                <v-col cols="12" class="mt-4 py-0">
                  <v-data-table
                    :headers="headersDetails"
                    :items="itemToShow.contexts"
                    item-key="itemToShow.id"
                    item-class="text-wrap"
                  >
                    <template #[`item.content`]="{ item }">
                      {{ item.content | slice100Characters }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="showDetailsJobDialog = false"> Close </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ContextsDataService from '@/services/ContextsDataService';
import JobsDataService from '@/services/JobsDataService';

export default {
  name: 'JobsList',
  data() {
    return {
      jobs: [],
      successfullJobs: false,
      messageJobs: '',
      contextsCreate: [],
      contextsEdit: [],
      successfullContexts: false,
      messageContexts: '',
      loading: false,
      successfullCreateJob: false,
      messageCreateJob: '',
      successfullCreateJobInside: false,
      messageCreateJobInside: '',
      successfullEditJob: false,
      messageEditJob: '',
      successfullEditJobInside: false,
      messageEditJobInside: '',
      successfullDeleteJob: false,
      messageDeleteJob: '',
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        {
          text: 'Number of contexts',
          value: 'contexts.length',
          sortable: false,
        },
        { text: 'Created at', value: 'createdAt', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalPages: 1,
        totalItems: 0,
      },
      job: {
        name: '',
        contexts: [],
        status: 1,
      },
      rules: [(v) => !!v || 'Required field'],
      createJobDialog: false,
      creatingJob: false,
      editJobDialog: false,
      editingJob: false,
      deleteJobDialog: false,
      deletingJob: false,
      itemToEdit: {},
      itemToDelete: {},
      itemToShow: {},
      headersDetails: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Content', value: 'content', sortable: false },
      ],
      showDetailsJobDialog: false,

      pageContextsCreate: 1,
      totalItemsContextsCreate: 0,
      itemsPerPageContextsCreate: 10,
      loadingContextsCreate: false,
      isMenuOpenCreate: false,
    };
  },
  async mounted() {
    await this.getAllContextsEdit();
    await this.getAllJobs(1);
  },
  methods: {
    getAllJobs(page) {
      this.loading = true;

      JobsDataService.findAll(page, this.pagination.itemsPerPage).then(
        (response) => {
          if (response.status == 200) {
            this.jobs = response.data.data;

            if (this.jobs.length !== 0) {
              this.pagination.page = page;
              this.pagination.totalPages = response.data.links.totalPages || 1;

              this.pagination.totalItems =
                response.data.links.totalItems ||
                this.pagination.totalPages * this.pagination.itemsPerPage;
            }
          } else {
            this.successfullJobs = false;
            this.messageJobs =
              'An error has occurred retrieving the list of jobs. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullJobs = false;
          this.messageJobs =
            'An error has occurred retrieving the list of jobs. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    handlePageChange(newPage) {
      this.pagination.page = newPage;
      this.getAllJobs(newPage);
    },
    observeMenuCreate() {
      const menu = this.$refs.menuContextsCreate;
      if (!menu) return;

      const observer = new MutationObserver(() => {
        this.$nextTick(() => {
          const dropdown = menu.$el.querySelector('.v-menu__content');

          if (dropdown && !this.isMenuOpenCreate) {
            this.onOpenContextsCreate(true);
            this.isMenuOpenCreate = true;
            dropdown.addEventListener('scroll', this.onScrollContextsCreate);
          } else if (!dropdown && this.isMenuOpenCreate) {
            this.onOpenContextsCreate(false);
            this.isMenuOpenCreate = false;
          }
        });
      });

      observer.observe(menu.$el, { childList: true, subtree: true });
    },
    getAllContextsCreate() {
      this.loadingContextsCreate = true;

      ContextsDataService.findAll(this.pageContextsCreate, this.itemsPerPageContextsCreate).then(
        (response) => {
          if (response.status == 200) {
            if (response.data.data.length === 0) {
              this.loadingContextsCreate = false;
              return;
            }

            this.contextsCreate = [...this.contextsCreate, ...response.data.data];
            this.totalItemsContextsCreate = response.data.links.totalItems;
            this.pageContextsCreate++;
          } else {
            this.successfullContexts = false;
            this.messageContexts =
              'An error has occurred retrieving the list of contexts. Please, try again later.';
          }

          this.loadingContextsCreate = false;
        },
        (error) => {
          this.successfullContexts = false;
          this.messageContexts =
            'An error has occurred retrieving the list of contexts. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loadingContextsCreate = false;
        }
      );
    },
    onOpenContextsCreate(isOpen) {
      if (isOpen && this.contextsCreate.length === 0) {
        this.getAllContextsCreate();
      }
    },
    onScrollContextsCreate(event) {
      const dropdown = event.target;

      if (
        dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 &&
        !this.loadingContextsCreate
      ) {
        this.getAllContextsCreate();
      }
    },
    getAllContextsEdit() {
      this.loading = true;

      ContextsDataService.findAll(-1, 0).then(
        (response) => {
          if (response.status == 200) {
            this.contextsEdit = response.data.data;
          } else {
            this.successfullContexts = false;
            this.messageContexts =
              'An error has occurred retrieving the list of contexts. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullContexts = false;
          this.messageContexts =
            'An error has occurred retrieving the list of contexts. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    openCreateJob() {
      this.createJobDialog = true;

      this.$nextTick(() => {
        this.observeMenuCreate();
      });
    },
    createJob() {
      this.successfullCreateJob = true;
      this.messageCreateJob = '';

      if (this.$refs.createJobForm.validate()) {
        this.creatingJob = true;

        this.job.contextsList = [...this.job.contexts];
        delete this.job.contexts;

        JobsDataService.create(this.job).then(
          (response) => {
            if (response.status == 201) {
              this.getAllJobs(1);

              this.messageCreateJob = '';
              this.successfullCreateJob = true;

              setTimeout(() => {
                this.messageCreateJob = 'Job successfully created.';
              }, 10);
            } else {
              this.messageCreateJob = '';
              this.successfullCreateJob = true;

              setTimeout(() => {
                this.messageCreateJob =
                  'An error has occurred creating the job. Please, try again later.';
              }, 10);
            }

            this.createJobDialog = false;
            this.creatingJob = false;
            this.job = {
              name: '',
              contexts: [],
              status: 1,
            };
          },
          (error) => {
            this.messageCreateJobInside = '';
            this.messageCreateJob = '';

            if (error.response.status === 409) {
              this.successfullCreateJobInside = false;

              setTimeout(() => {
                this.messageCreateJobInside = 'Job already in use. Please, change its name.';
              }, 10);
            } else if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            } else {
              this.successfullCreateJob = false;

              setTimeout(() => {
                this.messageCreateJob =
                  'An error has occurred creating the job. Please, try again later.';
              }, 10);

              this.createJobDialog = false;
              this.job = {
                name: '',
                contexts: [],
                status: 1,
              };
            }

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            this.creatingJob = false;
          }
        );
      }
    },
    cancelCreateJob() {
      this.createJobDialog = false;
      this.job = {
        name: '',
        contexts: [],
        status: 1,
      };
    },
    openEditJob(job) {
      this.itemToEdit = { ...job };

      const itemContexts = [...job.contexts];

      this.itemToEdit.contexts = [];
      itemContexts.forEach((context) => {
        this.itemToEdit.contexts.push(context.id);
      });

      this.editJobDialog = true;
    },
    editJob() {
      this.successfullEditJob = true;

      if (this.$refs.editJobForm.validate()) {
        this.editingJob = true;

        this.itemToEdit.contextsList = [...this.itemToEdit.contexts];
        delete this.itemToEdit.contexts;

        JobsDataService.update(this.itemToEdit).then(
          (response) => {
            if (response.status == 204) {
              this.getAllJobs(1);
              this.messageEditJob = '';
              this.successfullEditJob = true;

              setTimeout(() => {
                this.messageEditJob = 'Job successfully updated.';
              }, 10);
            } else {
              this.messageEditJob = '';
              this.successfullEditJob = true;

              setTimeout(() => {
                this.messageEditJob =
                  'An error has occurred updating the job. Please, try again later.';
              }, 10);
            }

            this.editJobDialog = false;
            this.editingJob = false;
            this.itemToEdit = {};
          },
          (error) => {
            this.messageEditJobInside = '';
            this.messageEditJob = '';

            if (error.response.status === 409) {
              this.successfullEditJobInside = false;

              setTimeout(() => {
                this.messageEditJobInside = 'Job already in use. Please, change its name.';
              }, 10);
            } else if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            } else {
              this.successfullEditJob = false;

              setTimeout(() => {
                this.messageEditJob =
                  'An error has occurred updating the job. Please, try again later.';
              }, 10);

              this.editJobDialog = false;
              this.itemToEdit = {};
            }

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            this.editingJob = false;
          }
        );
      }
    },
    openDeleteJob(job) {
      this.itemToDelete = { ...job };
      this.deleteJobDialog = true;
    },
    deleteJob() {
      if (this.itemToDelete.id !== undefined) {
        this.deletingJob = true;

        JobsDataService.delete(this.itemToDelete.id).then(
          (response) => {
            if (response.status == 204) {
              this.getAllJobs(1);
              this.messageDeleteJob = '';
              this.successfullDeleteJob = true;

              setTimeout(() => {
                this.messageDeleteJob = 'Job successfully deleted.';
              }, 10);
            } else {
              this.messageDeleteJob = '';
              this.successfullDeleteJob = false;

              setTimeout(() => {
                this.messageDeleteJob =
                  'An error has occurred deleting the job. Please, try again later.';
              }, 10);
            }

            this.deleteJobDialog = false;
            this.deletingJob = false;
            this.itemToDelete = {};
          },
          (error) => {
            this.messageDeleteJob = '';
            this.successfullDeleteJob = false;

            setTimeout(() => {
              this.messageDeleteJob =
                'An error has occurred deleting the job. Please, try again later.';
            }, 10);

            this.deleteJobDialog = false;
            this.itemToDelete = {};

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            }

            this.deletingJob = false;
          }
        );
      } else {
        this.messageDeleteJob = '';
        this.successfullDeleteJob = false;

        setTimeout(() => {
          this.messageDeleteJob =
            'An error has occurred deleting the job. Please, try again later.';
        }, 10);

        this.deleteJobDialog = false;
        this.itemToDelete = {};
      }
    },
    openShowDetails(job) {
      this.itemToShow = { ...job };
      this.showDetailsJobDialog = true;
    },
  },
};
</script>
